import React from 'react';
import SmallProfileDisplayList from '../../../smallProfileDisplay/SmallProfileDisplayList';

const styles = require('./CandidateSkillsDisplay.module.scss');

interface Skill {
  id: number;
  tag: string;
}

interface Props {
  color: string;
  skills: Skill[];
}

export default function CandidateSkillsDisplay(props: Props) {
  const skills = Object.values(props.skills).map(({ tag }: Skill) => ({
    title: tag,
  }));

  const renderTopSkills = () => (
    <div className={styles.skillsBlock}>
      <SmallProfileDisplayList color={props.color} skills={skills} />
    </div>
  );

  return <div className={styles.skillsSection}>{skills.length !== 0 && renderTopSkills()}</div>;
}
